<template>
  <div class="d-flex align-center mb-1" data-testid="tasklist__title-group">
    <h3 class="black--text font-weight-semibold ma-0" data-testid="tasklist__title">{{ title }}</h3>
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <base-button
          v-bind="attrs"
          v-on="on"
          icon="mdi-refresh"
          :icon-style="true"
          class="shadow-off ml-1"
          @click="$emit('refresh')"
          data-testid="tasklist__refresh-btn"
        />
      </template>
      <span>Refresh</span>
    </v-tooltip>
    <activity-log
      :resource-id="metadata._id"
      data-testid="financialclose-tasklist__activitylog-btn"
      row-description="Tasklist Bulk Actions"
      :type="normalizedActivityLogType"
    />
    <v-tooltip
      bottom
      content-class="tooltip-bottom"
      v-if="isNotificationEnabled"
    >
      <template v-slot:activator="{ on, attrs }">
        <base-button
          v-bind="attrs"
          v-on="on"
          image="/img/icons/EmailIcon.svg"
          imageAlt="email-icon"
          :icon-style="true"
          class="shadow-off"
          @click="$emit('email')"
          data-testid="tasklist__email-btn"
        />
      </template>
      <span>Email</span>
    </v-tooltip>
  </div>
</template>

<script>
import ActivityLog from '../../../components/ActivityLog/ActivityLog.vue';
import BaseButton from '@/views/common/BaseButton.vue';

export default {
  name: 'lb-header',
  components: {
    ActivityLog,
    BaseButton,
  },
  computed: {
    normalizedActivityLogType() {
      if (Array.isArray(this.activityLogType)) {
        return this.activityLogType;
      }
      if (typeof this.activityLogType === 'string' && this.activityLogType.trim()) {
        return [this.activityLogType];
      }
      return [];
    },
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    metadata: {
      type: Object,
      required: true,
    },
    isNotificationEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    activityLogType: {
      type: [Array, String],
      required: false,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
// Add any component-specific styles here
</style>
